var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.2 8.3L3.2 6.5L2 7.7L6.2 12.5L14 4.7L12.8 3.5L6.2 8.3Z","fill":"#181818"}));
}

Check.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Check;

Check.default = Check;
